import { isEmpty, isObject } from 'lodash'
import Cookies from 'js-cookie'
import store from '@/store'

/**
 * 返回全局变量
 */
export function globalVar() {
  const contact = store?.state?.system?.platformConfig?.contact || {}
  return {
    phone: contact?.consumerHotline || '400-8566-100',
    qqLink:
      contact?.qqLink || 'tencent://message/?uin=811028657&Site=&Menu=yes',
    email: contact?.consumerEmail || 'kefu@jczh.com',
    workTime: contact?.workTime || '08:30-12:00 14:00-17:30'
  }
}

/**
 * 返回OSS资源的完整路径
 * @param ossPath {string} 不带域名的资源链接
 */
export function getOSSUrl(ossPath) {
  if (!ossPath) return

  return `${process.env.VUE_APP_OSS_URL}/${ossPath}`
}

/**
 * 跳转至登录平台
 */
export function toLogin() {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null

  store.dispatch('system/toPlatform', {
    platform: 'login',
    query: { returnUrl: encodeURIComponent(window.location.href) },
    target: '_self'
  })
}

/**
 * 跳转至会员购买页
 */
export function toVipBuy(router) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null

  router.push({
    name: 'VipBuy'
  })
}

/**
 * 跳转标书预览购买页面
 */
export function toBidFilePreviewBuy(data) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const extraStr = toStringOnPath(data || {})
  const url = `${
    process.env.VUE_APP_PORTAL_URL
  }/value-added/bid-file-preview/buy${extraStr ? `?${extraStr}` : ''}`
  window.open(addQueryToUrl(url), '_blank')
}

/**
 * 跳转至云采购门户公告页
 */
export function toPortalNotice({ noticeId = '', noticeUrl = '' }) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  store.dispatch('system/toPlatform', {
    platform: 'login',
    path: `/notice/${noticeId}`,
    url: noticeUrl
  })
}

/**
 * 跳转到支付中心
 * @param {string} payCode 支付订单号
 */
export function toPayCenter(payCode) {
  // 跳转到支付页面
  store.dispatch('system/toPlatform', {
    platform: 'payCtr',
    path: `/order/${payCode}`
  })
}

/**
 * 跳转到支付确认页面
 * @param skuId
 * @param data
 */
export function toPayCenterOrderConfirm(skuId, data) {
  const { payCode } = data
  if (payCode) {
    toPayCenter(payCode)
    return
  }

  store.dispatch('system/toPlatform', {
    platform: 'payCtr',
    path: '/order/confirm',
    query: Object.assign({}, data, { skuId })
  })
}

/**
 * 跳转到AI标书审查记录页面
 */
export function toAiCheckRecord(data) {
  store.dispatch('system/toPlatform', {
    platform: 'login',
    path: '/personal-center/value-added-services/ai-check'
  })
}

/**
 * 字符串货币格式化
 * @param {string} numStr 数字字符串，可带小数
 */
export function strToThousands(numStr) {
  if (numStr == null || numStr == undefined) return numStr
  return numStr.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ','
    })
  })
}

/**
 * 对象数组去重
 * @param {Array} arr 对象数组
 * @param {string} key 用于识别重复的属性名，默认使用'id'
 */
export function unique(arr, key = 'id') {
  const res = new Map()
  return arr.filter(
    (current) => !res.has(current[key]) && res.set(current[key], 1)
  )
}

/**
 * 将对象转换成页面路径传参的字符串
 * @param {Object} object
 * @returns {string}
 */
export function toStringOnPath(object) {
  if (!isObject(object)) return ''

  const stringArray = []
  for (const key in object) {
    stringArray.push(`${key}=${object[key]}`)
  }
  return stringArray.join('&')
}

/**
 * 解析字符串实现对象属性路径访问
 * @param {Object} obj 要访问的对象
 * @param {String} path 属性路径字符串
 * @returns {null|*} 对应的属性值
 */
export function getPropByPath(obj, path) {
  let tempObj = obj
  path = path?.replace(/\[(\w+)\]/g, '.$1')
  path = path?.replace(/^\./, '')

  const keyArr = path?.split('.') || []
  let i = 0
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj) break
    const key = keyArr[i]
    if (key in tempObj) {
      tempObj = tempObj[key]
    } else {
      return null
      // break;
    }
  }
  return tempObj ? tempObj[keyArr[i]] : null
}

/**
 * 字符串按字数限制省略
 * @param {string} str 目标字符串
 * @param {number} size 限制显示的字数
 * @returns {string} 省略后的字符串
 */
export function stringEllipsis(str = '', size = 150) {
  if (str.length > size) {
    str = str.substring(0, size - 1) + '...'
  }
  return str
}

/**
 * 将query参数添加到url中 并 返回新的url，默认会携带上ac
 * @param oldUrl {String} 原url
 * @param queryObj {Object} 需要增加的query参数
 * @param needAC {Boolean} 是否需要自动携带ac
 * @return {String} 新url
 */
export function addQueryToUrl(oldUrl, queryObj = {}, needAC = true) {
  const whiteListConfig = {
    staticDomains: [],
    patternDomains: ['.jczh.com', 'yingcaicheng.net']
  }
  function isValidTarget(urlStr) {
    let url
    try {
      url = new URL(urlStr)
    } catch {
      return false
    }
    const hostname = url.hostname.toLowerCase()
    if (whiteListConfig.staticDomains.includes(hostname)) {
      return true
    }
    return whiteListConfig.patternDomains.some((domain) => {
      const d = domain.replace(/^\./, '').toLowerCase()
      return hostname === d || hostname.endsWith(`.${d}`)
    })
  }
  const ac = Cookies.get('X-JCZH-AC')
  queryObj = Object.assign(
    {},
    needAC && ac && isValidTarget(oldUrl) ? { 'x-jczh-ac': ac } : {},
    queryObj
  )
  if (!oldUrl || isEmpty(queryObj)) return oldUrl

  const tempUrl = oldUrl.split('#')[0] || ''
  const hashUrl = oldUrl.split('#')[1] || ''
  const mainUrl = tempUrl.split('?')[0] || ''
  const queryUrl = tempUrl.split('?')[1] || ''

  let queryUrlObj = {}
  queryUrl.split('&').forEach((value) => {
    if (!value) return

    const temp = value.split('=')
    queryUrlObj[temp[0]] = temp[1]
  })
  queryUrlObj = Object.assign({}, queryUrlObj, queryObj)

  const queryList = Object.keys(Object.assign({}, queryUrlObj, queryObj)).map(
    (key) => {
      return `${key}=${queryUrlObj[key]}`
    }
  )

  let newUrl = mainUrl
  if (queryList.length) {
    newUrl = `${newUrl}?${queryList.join('&')}`
  }
  if (hashUrl) newUrl = `${newUrl}#${hashUrl}`

  return newUrl
}
